import request from '@/util/request';
import qs from 'qs';



// 获取项目下拉框
export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取系统字典
export const getDictData = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

